import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { mapResponse } from 'src/lib/utilities/api/map-response';
import {
	CourseRegistrationsResponseModel,
	CourseRegistrationsSearchArgument,
} from './course-registrations.model';

@Injectable({
	providedIn: 'root',
})
export class CourseRegistrationsService {
	constructor(private httpClient: HttpClient) {}

	public searchCourseRegistrations = (
		args: CourseRegistrationsSearchArgument,
	): Observable<CourseRegistrationsResponseModel> => {
		return this.httpClient
			.post<unknown>(`/api/v1/registration/search`, args)
			.pipe(
				mapResponse(
					(r) => plainToInstance(CourseRegistrationsResponseModel, r),
					{ errorCode: '9B4A2819' },
				),
			);
	};

	public reissueCertificate = (
		studentId: number,
		registrationId: number,
	): Observable<unknown> => {
		return this.httpClient.post<unknown>(
			`/api/v1/students/${studentId}/classes/${registrationId}/certification/reissue`,
			{},
		);
	};
}
